export const CACHE = {
  ORIGAMI: 'origami'
};
